import React, { useState, useEffect } from 'react';
import soundFile from './end.wav'; // Import your sound file
import "./countdown.css"

function CountdownTimer(props) {

    useEffect(() => {



        const countToDate = new Date().getTime() + props.countdown * 1000;


      
        const flipAllCards = (time) => {
          const seconds = time % 60;
          const totalMinutes = Math.floor(time / 60);
          const minutes = totalMinutes;
          const hours = Math.floor(totalMinutes / 60);
        
  
          // Now you have hours, minutes, and seconds that can go past their usual limits.
          // You can use these values to update your DOM elements as needed.
        
          // Example: Update the hours, minutes, and seconds in your DOM elements
          flip(document.querySelector("[data-hours-tens]"), Math.floor(hours / 10));
          flip(document.querySelector("[data-hours-ones]"), hours % 10);
          flip(document.querySelector("[data-minutes-tens]"), Math.floor(minutes / 10));
          flip(document.querySelector("[data-minutes-ones]"), minutes % 10);
          flip(document.querySelector("[data-seconds-tens]"), Math.floor(seconds / 10));
          flip(document.querySelector("[data-seconds-ones]"), seconds % 10);
        };
      
        const flip = (flipCard, newNumber) => {
          const topHalf = flipCard.querySelector(".top");
          const startNumber = parseInt(topHalf.textContent);
          if (newNumber === startNumber) return;
      
          const bottomHalf = flipCard.querySelector(".bottom");
          const topFlip = document.createElement("div");
          topFlip.classList.add("top-flip");
          const bottomFlip = document.createElement("div");
          bottomFlip.classList.add("bottom-flip");
      
          topHalf.textContent = startNumber;
          bottomHalf.textContent = startNumber;
          topFlip.textContent = startNumber;
          bottomFlip.textContent = newNumber;
      
          topFlip.addEventListener("animationstart", (e) => {
            topHalf.textContent = newNumber;
          });
          topFlip.addEventListener("animationend", (e) => {
            topFlip.remove();
          });
          bottomFlip.addEventListener("animationend", (e) => {
            bottomHalf.textContent = newNumber;
            bottomFlip.remove();
          });
          flipCard.append(topFlip, bottomFlip);
        };
      
        let previousTimeBetweenDates;
      
        const timer = setInterval(() => {

          if (!props.isRunning) {
            clearInterval(timer);
            return;
          }

          const currentDate = new Date();
          const timeBetweenDates = Math.ceil((countToDate - currentDate) / 1000);
          flipAllCards(timeBetweenDates);
      
          previousTimeBetweenDates = timeBetweenDates;
      
          if (previousTimeBetweenDates <= 0) {
            props.stopCounter1()
            clearInterval(timer);
          }
        }, 250);
      
        return () => clearInterval(timer);
      }, [props.countdown,props.isRunning]);
      

      
  const handleStart = () => {
    props.setCountdown(props.time * 60); // Convert minutes to seconds
    props.setIsRunning(true);
  };

  const handlePause = () => {
    props.setIsRunning(false);
  };

  const handleUnpause = () => {
    props.setIsRunning(true);
  };

  const handleReset = () => {
    props.setIsRunning(false);
    props.setCountdown(0);
    props.resetTime(0);
  };

  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;

    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  const playSound = () => {
    const audio = new Audio(soundFile);
    audio.play();
  };


  return (
    <div className="countBody">
 
  
 
      <div class="container" style={{marginTop:"50px"}}>
    <div class="container-segment" style={{display:'none'}}>
      <div class="segment">
        <div class="flip-card" data-hours-tens>
          <div class="top">0</div>
          <div class="bottom">0</div>
        </div>
        <div class="flip-card" data-hours-ones>
          <div class="top">0</div>
          <div class="bottom">0</div>
        </div>
      </div>
    </div>
    <div class="container-segment">
      <div class="segment" style={{opacity:1}}>
        <div class="flip-card" data-minutes-tens>
          <div class="top">0</div>
          <div class="bottom">0</div>
        </div>
        <div class="flip-card" data-minutes-ones>
          <div class="top">0</div>
          <div class="bottom">0</div>
        </div>
      </div>
    </div>
  
    <div class="container-segment" >
      <div class="segment">
        <div class="flip-card" data-seconds-tens>
          <div class="top">0</div>
          <div class="bottom">0</div>
        </div>
        <div class="flip-card" data-seconds-ones>
          <div class="top">0</div>
          <div class="bottom">0</div>
        </div>
      </div>
    </div>
  </div>
      
    </div>
  );
}

export default CountdownTimer;
